import { AppID } from '@ikonintegration/idmclient';
//
import APIRequest from './core/Request';
// API Components
import ClassificationUnit from './operations/ClassificationUnit';
import Contact from './operations/Contact';
import OperationOrganization from './operations/Organization';
import OperationOrganizationApp from './operations/OrganizationApp';
import OrganizationAppContact from './operations/OrganizationAppContact';
import OrganizationAppCU from './operations/OrganizationAppCU';
import OrganizationAppInvitation from './operations/OrganizationAppInvitation';
import OrganizationAppInvitationHistory from './operations/OrganizationAppInvitationHistory.js';
import OrganizationAppLocation from './operations/OrganizationAppLocation';
import OrganizationAppMember from './operations/OrganizationAppMember';
import OrganizationCU from './operations/OrganizationCU';
import OrganizationEmployee from './operations/OrganizationEmployee';
import OrganizationsImportJob from './operations/OrganizationsImportJob';
import OrganizationsImportJobSourceFile from './operations/OrganizationsImportJobSourceFile';
//
export default class Client {
  /* config structure
    {
      endpoint: 'https://localhost',
      port: 9998,
      apiKey: '',
      tenantID: '',
      customerID: '',
      authorizationToken: '' -- optional
    }
  */
  constructor(config) {
    this.config = config;
    // api operations
    this.contact = new Contact(this);
    this.classificationUnit = new ClassificationUnit(this);
    this.employee = new OrganizationEmployee(this);
    this.organization = new OperationOrganization(this);
    this.organizationApp = new OperationOrganizationApp(this);
    this.organizationAppContact = new OrganizationAppContact(this);
    this.organizationAppCU = new OrganizationAppCU(this);
    this.organizationAppInvitation = new OrganizationAppInvitation(this);
    this.organizationAppInvitationHistory = new OrganizationAppInvitationHistory(this);
    this.organizationAppLocation = new OrganizationAppLocation(this);
    this.organizationAppMember = new OrganizationAppMember(this);
    this.organizationCU = new OrganizationCU(this);
    this.organizationsImportJob = new OrganizationsImportJob(this);
    this.organizationsImportJobFile = new OrganizationsImportJobSourceFile(this);
  }

  async newBaseRequest(method) {
    const req = new APIRequest(method);
    //Auth
    if (this.config.apiKey) {
      const iToken = new AppID(null, this.config.apiKey, this.config.apiKey);
      req.appendHeader('API-Key', iToken.getHash());
    }
    if (this.config.authorizationToken) {
      let token = this.config.authorizationToken;
      if (typeof this.config.authorizationToken === "function") {
        token = await this.config.authorizationToken();
      }
      req.appendHeader('Authorization', token);
    }
    if (this.config.tenantID) req.appendHeader('tenantID', this.config.tenantID);
    if (this.config.customerID) req.appendHeader('customerID', this.config.customerID);
    //
    req.baseURL = this.config.endpoint;
    if (this.config.port) req.baseURL += `:${this.config.port}`;
    //
    return req;
  }
}
